import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './pwaInstall'; // Side-effect import: registers the beforeinstallprompt listener

// ═══════════════ SERVICE WORKER REGISTRATION ═══════════════
function registerServiceWorker() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/service-worker.js');
        console.log('SW registered:', registration.scope);
        setInterval(() => registration.update(), 60 * 60 * 1000); // Every hour
      } catch (err) {
        console.error('SW registration failed:', err);
      }
    });
  }
}

// ═══════════════ RENDER ═══════════════
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
